import React from "react";
import {DatePicker, Input, message, Modal, Table, Tooltip} from "antd";
import {WorkOrderList, WorkOrderRemove, WorkOrderUpdate} from "../../../models/workorder";
import {pagination} from "../../../controller/Utils";
import {Config} from "../../../controller/Global";
import {TrackHeaderLink} from "../TrackHeaderLink";

const moment = require('moment');

const { RangePicker } = DatePicker;
const confirm = Modal.confirm;
const Search = Input.Search;
const WORKORDER = 'workorder';
const MANIFEST = Config.constant.service_type.manifest;

export class Trash extends React.Component {
  state = {
    data: [],
    pagination: pagination,
    value: [],
    loading: false,
    selectedRowKeys: [],
    params: {},
  };

  handleCancel = () => {
    this.setState({
      printVisible: false,
    });
  }

  onCheckboxSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    let symbol = '';
    if (sorter.order === 'descend')
      symbol = '-';
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      ordering: `${symbol}${sorter.field}`,
      ...filters,
    });
  };
  fetch = (params = {}) => {
    this.setState({ loading: true, params: params });
    params['type'] = 'trash';
    WorkOrderList(params)
      .then(response => {
        const pagination = { ...this.state.pagination };
        pagination.total = response.data.count;
        this.setState({
          loading: false,
          data: response.data.results,
          pagination,
        });
      });
  };
  onDateRangeChange = (date, dateString) => {
    this.fetch({
      date_fields: 'created',
      start_date: dateString[0],
      end_date: dateString[1]
    })
  };


  onMultipleRowDeleteClick = () => {
    const {selectedRowKeys} = this.state;
    if (selectedRowKeys.length)
      this.onRowDeleteClick(selectedRowKeys);
    else
      message.info('Please select any one row for delete');
    this.setState({
      selectedRowKeys: []
    })
  };

  onMultipleRowRestoreClick = () => {
    const {selectedRowKeys} = this.state;
    if (selectedRowKeys.length)
      this.onRowRestoreClick(selectedRowKeys);
    else
      message.info('Please select any one row for restore');
    this.setState({
      selectedRowKeys: []
    })
  };

  onRowDeleteClick = (keys) => {
    const $this = this;
    confirm({
      title: 'Are you sure delete this work order(s)?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      centered: true,
      onOk() {
        keys.forEach(id => {
          WorkOrderRemove(id)
            .then(response => {
              message.success('Work Order(s) deleted successfully');
              $this.fetch();
            });
        });
      },
    });
  };
  onRowRestoreClick = (keys) => {
    const $this = this;
    confirm({
      title: 'Are you sure restore this work order(s)?',
      okText: 'Yes',
      okType: 'success',
      cancelText: 'No',
      centered: true,
      onOk() {
        keys.forEach(id => {
          WorkOrderUpdate(id, {'is_delete': false})
            .then(response => {
              message.success('Work Order(s) restored successfully');
              $this.fetch();
            });
        });
      },
    });
  }
  onRowShowClick = (ids) => {
    this.setShowWorkOrderModel(true);
    this.setState({ showWorkOrderModelData: ids })
  };
  onRowUpdateClick = (moderatedWorkOrder) => {
    this.setState({ moderatedWorkOrder });
    this.setAddUpdateWorkOrderModel(true);
  };
  columns = [
    {
      title: 'Action',
      render: item => <div className="action-column">
        <a title="Delete" onClick={() => this.onRowDeleteClick([item.id])}><i className="fa fa-trash" /></a>
        <a title="Restore" onClick={() => this.onRowRestoreClick([item.id])}><i className="fa fa-undo" /></a>
      </div>
    }, {
      title: 'Created Date',
      dataIndex: 'created',
      sorter: true,
      render: created => moment(created).format('YYYY-MM-DD')
    }, {
      title: 'Work Order Number',
      dataIndex: 'work_order_number',
      sorter: true
    }, {
      title: <span className="billto-column-tbl">Generator</span>,
      dataIndex: 'generator',
      render: generator => <Tooltip placement="top" title={`${generator.address} ${generator.city} ${generator.zip_code}`}><span className="uppercase-letter">{generator.company_name}<br />ID: {generator.account_number}<i className="fa fa-info-circle" /></span></Tooltip>,
      sorter: true
    }, {
      title: <span className="billto-column-tbl">User</span>,
      dataIndex: 'user',
      render: (user) => user ? `${user.first_name} ${user.last_name}` : 'N/A',
      sorter: true
    }, {
      title: <span className="billto-column-tbl">Bill To</span>,
      dataIndex: 'bill_to',
      render: bill_to => <span>{bill_to.company_name}<br /> ID: {bill_to.account_number}</span>,
      sorter: true
    }
  ];

  componentDidMount() {
    this.fetch();
  }

  render() {
    const {pagination, data, loading, selectedRowKeys, row_id} = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onCheckboxSelectChange,
    };
    return <div id="main-content">
      <div className="container-fluid">
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-sm-3 col-12">
              <h3 className="main-heading">AB Tracks</h3>
            </div>
            <div className="col-sm-9 col-12">
              <TrackHeaderLink/>
            </div>
          </div>
          <div className="row clearfix edit-header">
            <div className="col-sm-4 col-12">
              <div id="date_range_wrapper">
                <RangePicker onChange={this.onDateRangeChange} />
              </div>
            </div>
            <div className="col-sm-3 col-10 pull-xs-right">
              <Search placeholder="Input search text" onSearch={value => this.fetch({ search: value })}
                style={{ width: "100%" }} />
            </div>
            <div className="col-sm-5 col-12 edit-div">
              <span>{pagination.total} Records</span>

              <button className="btn btn-edit" onClick={this.onMultipleRowDeleteClick}>
                <i className="fa fa-trash-o" />
              </button>
              <button className="btn btn-edit" onClick={this.onMultipleRowRestoreClick}>
                <i className="fa fa-undo" />
              </button>
            </div>
          </div>
          <div className="row clearfix">
            <div className="col-12">
              <div className="listing-table">
                <Table
                  className="responsive-table table table-hover js-basic-example dataTable table-custom table-striped m-b-0 c_list"
                  pagination={pagination} rowSelection={rowSelection} rowKey={row => row.id} columns={this.columns}
                  dataSource={data} loading={loading} onChange={this.handleTableChange}
                  locale={{ emptyText: 'No Work Order Available' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/pages/tracks/trash/Trash.jsx